import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Modal from 'react-bootstrap/Modal';
import { usePostFeatureableAssignments } from '../../../../../services/wire/featureable-service';
import useFeatureWireStore from './state-hooks';
import Author from './author';
import Mentions from './mentions';

const SModal = styled(Modal)`
  & > article.horizontal {
    width: 505px;
    height: fit-content !important;
    border-radius: 6px;
    padding: 40px 32px;
  }
`;

const Body = styled(Modal.Body)`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Headline = styled.div`
  font-size: 24px;
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightHeavy};
  line-height: 100%;
  text-align: center;
  text-transform: uppercase;
`;

const Text = styled.p`
  font-size: 19px;
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightRegular};
  line-height: 120%;
  text-align: center;
  letter-spacing: -0.02em;
`;

const OptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 16px 40px 40px;
`;

const Button = styled.button`
  margin-left: 16px;
  float: right;

  &.btn {
    border-width: 1px;
  }
`;

export default function FeatureWireModal({ wireId }) {
  const set = useFeatureWireStore(state => state.set);
  const showModal = useFeatureWireStore(state => state.showModal);
  const selectedFeatureable = useFeatureWireStore(state => state.selectedFeatureable);
  const [, post] = usePostFeatureableAssignments(wireId, { featureables: selectedFeatureable });

  const hide = e => {
    e && e.preventDefault();

    set(state => {
      state.showModal = false;
    });
  };

  const saveFeatureableAssignments = e => {
    e && e.preventDefault();

    post().then(() => (
      set(state => {
        state.showModal = false;
      })
    ));
  };

  return (
    <SModal
      centered="true"
      dialogAs="article"
      dialogClassName="horizontal"
      show={showModal}
      backdrop="static"
    >
      <Body>
        <Headline>Select Profiles to feature this wire</Headline>
        <Text>
          When published, this will update and pin this as the first featured wire
          for selected profiles.
        </Text>
        <OptionContainer>
          <Author />
          <Mentions />
        </OptionContainer>
      </Body>
      <Modal.Footer>
        <Button type="button" className="btn btn-primary" onClick={saveFeatureableAssignments}>
          Confirm
        </Button>
        <Button type="button" className="btn btn-default" onClick={hide}>
          Cancel
        </Button>
      </Modal.Footer>
    </SModal>
  );
}

FeatureWireModal.propTypes = { wireId: PropTypes.number.isRequired };
